import { render } from "./StudentContract.vue?vue&type=template&id=34f7bd8a&scoped=true"
import script from "./StudentContract.vue?vue&type=script&lang=js"
export * from "./StudentContract.vue?vue&type=script&lang=js"

import "./StudentContract.vue?vue&type=style&index=0&id=34f7bd8a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.1.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f7bd8a"]])

export default __exports__